import _ from "lodash";
import currencyFormatter from "currency-formatter";
import React, { useEffect, useState } from "react";
import styled, { cx, css } from "react-emotion";
import useWindowSize from "../../hooks/useWindowSize";

function money(value, { symbol = true } = {}) {
  return currencyFormatter.format(value, {
    thousand: ".",
    symbol: "€",
    precision: 0,
    format: symbol ? "%v %s" : "%v",
  });
}

function KaInputText(props) {
  const {
    mountWithFocus,
    id,
    label,
    data,
    inputWidth = "",
    labelWidth = "",
    size = "md",
    formGroupAdd = [],
    inputGroupAdd = [],
    name,
    inputStyle,
    placeholder,
    onChange: onChangeProp,
    onKeyPress,
    onKeyUp,
    onKeyDown,
    type,
    darkBg,
    errors,
    mobileInline = false,
    inputGroup = false,
    mobileGroup = false,
    animatedLabel = true,
    animatedLabelAbove = false,
    errorPositionAbsolute = false,
    errorOnTop = false,
    tall = props.type === "textarea",
    rows = 3,
    additionalInfo = null,
  } = props;

  function onChange(e) {
    if (type === "money") {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    } else if (type === "number") {
      e.target.value = Number(e.target.value);
    }

    onChangeProp(e);
  }

  const [focus, setFocus] = useState(false);
  const windowSize = useWindowSize();

  const inputRef = React.createRef();

  const mobileStyled = !mobileInline && windowSize.isMobile;

  let value = _.get(data, name) || "";

  if (type === "money") {
    value = money(value, { symbol: false });
  }
  if (type === "number") {
    value = Number(value);
  }

  const InputTag = type === "textarea" ? "textarea" : "input";

  const animatedLabelUp = animatedLabel && (focus || value);

  let inputEl =
    type === "blank" ? null : (
      <InputTag
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={!animatedLabel || animatedLabelUp ? placeholder : null}
        className={["form-control", inputGroup && inputWidth].filter(Boolean).join(" ")}
        onKeyPress={onKeyPress}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        ref={inputRef}
        id={id}
        style={inputStyle}
        name={name}
        onChange={onChange}
        type={type === "money" ? "tel" : type}
        value={value}
        aria-label={label}
        rows={type === "textarea" ? rows : null}
      />
    );

  if (type === "money") {
    inputEl = (
      <div className="money position-relative">
        {(animatedLabelUp || !animatedLabel) && <span className="moneySign">€</span>}
        {inputEl}
      </div>
    );
  }

  useEffect(() => {
    if (mountWithFocus) inputRef.current.focus();
  }, []);

  function onFocus(e) {
    const { onFocus } = props;
    setFocus(true);
    onFocus && onFocus(e);
  }

  function onBlur(e) {
    const { store, name, validateOnBlur = true, onBlur } = props;

    // if (validateOnBlur) store.validate([name]);
    // else store.clearField(name);

    setFocus(false);
    onBlur && onBlur(e);
  }

  return (
    <div
      className={[
        "KaInputText",
        props.className,
        animatedLabelAbove && "animatedLabelAbove",
        darkBg && "darkBg",
        animatedLabel && "placeholderToLabel",
        type === "textarea" && "textarea",
        tall && "tall",
        type === "money" && "money",
        focus && "focus",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div
        className={[
          inputGroup && (mobileGroup || !mobileStyled) && "input-group",
          "position-relative",
          `input-group-${size}`,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {label && (
          <label
            htmlFor={id}
            onClick={() => inputRef.current && inputRef.current.focus()}
            className={[
              "control-label",
              labelWidth,
              animatedLabelUp ? "labelActive" : "labelUnactive",
              animatedLabelUp ? "lActive" : "lUnactive",
            ].join(" ")}
          >
            <span className="labelText">{label || name}</span>
            {!animatedLabelAbove && <span className={["bg", "labelBackground"].join(" ")} />}
            {errorOnTop && errors && errors[name] && (
              <span className="error">
                <small>{errors[name][0]}</small>
              </span>
            )}
          </label>
        )}

        {!inputGroup && (
          <div className={inputWidth}>
            {inputEl}
            {additionalInfo && <div className={"additionalInfo"}>{additionalInfo}</div>}
          </div>
        )}
        {inputGroup && inputEl}

        {(mobileGroup || !mobileStyled) && inputGroupAdd}

        {formGroupAdd}
      </div>

      {!errorOnTop && errors && errors[name] && (
        <p className={cx(["error", errorPositionAbsolute && "errorPositionAbsolute"])}>
          <small>{errors[name][0]}</small>
        </p>
      )}

      {!mobileGroup && mobileStyled && inputGroupAdd}
    </div>
  );
}

KaInputText = styled(KaInputText)`
  .moneySign {
    line-height: 15px;
  }
  .error {
    text-align: left !important;
  }
  .errorPositionAbsolute {
    position: absolute;
  }
  .additionalInfo {
    position: absolute;
    right: 10px;
    top: 38px;
  }
`;

export default KaInputText;
